import DOMPurify from "dompurify";
import { Sparkles } from "lucide-react";

function narrativeToHtml(narrative) {
  return DOMPurify.sanitize(
    narrative
      .replace(/^## (.*$)/gm, "<h2>$1</h2>")
      .replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>")
      .replace(/^- (.*$)/gm, "<li>$1</li>")
      .replace(/(<li>.*<\/li>\n?)+/g, "<ul>$&</ul>")
      .replace(/\n\n/g, "</p><p>")
      .replace(/^([^<].*)$/gm, "<p>$1</p>")
  );
}

export function NarrativeCard({ narrative }) {
  if (!narrative) return null;
  return (
    <div className="border border-[#D8D4C7] bg-[#FDFBF7] paper-grain p-6 lg:p-10 relative fade-in" data-testid="ai-narrative-card">
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-[#A67C00]" />
      <div className="flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] uppercase text-[#A67C00]">
        <Sparkles className="w-3.5 h-3.5" /> GPT-5.4 Mini Monthly Brief
      </div>
      <div
        className="mt-4 font-serif text-lg lg:text-xl leading-relaxed max-w-3xl [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:mt-6 [&_h2]:mb-2 [&_h2]:tracking-tight [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_li]:font-serif [&_strong]:font-semibold [&_p]:mt-2"
        dangerouslySetInnerHTML={{ __html: narrativeToHtml(narrative) }}
      />
    </div>
  );
}
